import { render, staticRenderFns } from "./routingrule.vue?vue&type=template&id=5dc77973"
import script from "./routingrule.vue?vue&type=script&lang=js"
export * from "./routingrule.vue?vue&type=script&lang=js"
import style0 from "./routingrule.vue?vue&type=style&index=0&id=5dc77973&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports